import { useTickerStoreBase } from 'stores/ticker/ticker.store';
import { TickerData } from 'types/Ticker';

const updateAllTickers = (tickerList: TickerData[]) => {
  useTickerStoreBase.getState().actions.updateAllTickers(tickerList);
};

const updateTicker = (payload: TickerData) => {
  useTickerStoreBase.getState().actions.updateTickerData(payload);
};

const updateOpenPositionSpotPrices = (data: { s: string; p: number }) => {
  useTickerStoreBase.getState().actions.updateOpenPositionSpotPrice(data);
};

export { updateAllTickers, updateTicker, updateOpenPositionSpotPrices };
